import api from "./api";

const apiUrl = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_API_URL_LOCAL :  process.env.VUE_APP_API_URL;
export default {
	createSession() {
		return api.get(apiUrl + 'sanctum/csrf-cookie');
	},

	login(params) {
		return api.post(apiUrl +'api/login', params);
	},

	directLogin(params) {
		return api.post(apiUrl +'api/direct-login', params);
	},

	logout() {
		return api.delete(apiUrl + 'api/logout');
	},

	register(params) {
		return api.post(apiUrl + 'api/register', params);
	},

	registerAddress(params) {
		return api.post(apiUrl + 'api/register/address', params);
	},

	registerContract(params) {
		return api.post(apiUrl + 'api/register/contract', params);
	},

	registerShifts(params) {
		return api.post(apiUrl + 'api/register/shifts', params);
	},

	registerJobTypes(params) {
		return api.post(apiUrl + 'api/register/jobtypes', params);
	},

	registerTransportation(params) {
		return api.post(apiUrl + 'api/register/transportation', params);
	},

	getFunctions() {
		let query = '?locale=' + localStorage.getItem('locale');
		return api.get(apiUrl + 'api/getFunctions' + query);
	},

	getLanguages() {
		return api.get(apiUrl + 'api/getLanguages');
	},

	getCountries() {
		return api.get(apiUrl + 'api/getCountries');
	},

	loginSocial(params) {
		let data = {social: params}
		return api.post(apiUrl + 'api/login-social', data);
	},

	isActiveToggle(data) {
		return api.post(apiUrl + 'api/isActiveToggle', data);
	},

	forgotPassword(data) {
		return api.post(apiUrl + 'api/forgot-password', data);
	},

	resetPassword(data) {
		return api.post(apiUrl + 'api/reset-password', data);
	},

	checkAuth(data) {
		return api.post(apiUrl + 'api/checkAuth', data);
	},
	
	getAssessmentKey(data) {
		return api.post(apiUrl + 'api/getAssessmentKey', data);
	}
};
